<template>
    <div class="miniMatchCardTbd miniMatchCard">
        <div class="miniMatchCard_teamInfo">
            <div class="miniMatchCard_dateInfo">
                <span class="miniMatchCard_time">
                    {{ dateDisplay }} {{ timeDisplay }}
                </span>
            </div>
            <div class="miniMatchCard_teams">
                <div class="miniMatchCard_teamRow">
                    <div class="miniMatchCard_teamNameContainer">
                        <picture>
                            <source
                                v-bind:srcset="`${homeTeamLogo.webp}`"
                                type="image/webp"
                            />
                            <img
                                v-bind:src="`${homeTeamLogo.origin}`"
                                alt="Unknown flag"
                                class="miniMatchCard_flag"
                            />
                        </picture>
                        <div class="miniMatchCard_teamName">
                            {{ homeTeam }}
                        </div>
                    </div>
                </div>
                <div class="miniMatchCard_teamRow">
                    <div class="miniMatchCard_teamNameContainer">
                        <picture>
                            <source
                                v-bind:srcset="`${awayTeamLogo.webp}`"
                                type="image/webp"
                            />
                            <img
                                v-bind:src="`${awayTeamLogo.origin}`"
                                alt="Unknown flag"
                                class="miniMatchCard_flag"
                            />
                        </picture>
                        <div class="miniMatchCard_teamName">
                            {{ awayTeam }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="miniMatchCard_oddsInfo">
            {{ comingSoonText }}
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, toRefs } from 'vue';
    import { getTournamentCenterTeamImage } from '@/components/tournamentCenter/tournamentCenterHelper';
    import { formatDate } from '@/core/lib/date';
    import { i18n } from '@/core/lib/i18n';
    import { getTranslated } from '@/core/lib/translationHelper';
    import type { IKnockoutEvent } from '@/interface/tournamentCenter';

    const props = defineProps<{
        event: IKnockoutEvent;
    }>();

    const { event } = toRefs(props);

    const dateDisplay = computed(() => (event.value.datetime ? formatDate(event.value.datetime, 'MM/dd') : ''));
    const timeDisplay = computed(() => (event.value.datetime ? formatDate(event.value.datetime, 'HH:mm') : ''));
    const homeTeam = computed(() => (event.value.homeTeam ? getTranslated(event.value.homeTeam?.teamName) : (event.value.homePlaceHolder || 'TBD')));
    const awayTeam = computed(() => (event.value.awayTeam ? getTranslated(event.value.awayTeam?.teamName) : (event.value.awayPlaceHolder || 'TBD')));

    const homeTeamLogo = computed(() => getTournamentCenterTeamImage(event.value.homeTeam?.countryName));
    const awayTeamLogo = computed(() => getTournamentCenterTeamImage(event.value.awayTeam?.countryName));
    const comingSoonText = computed(() => i18n.t('tournament_center_status_coming_soon'));
</script>

<style lang="scss" scoped>
    @import "@/components/tournamentCenter/MiniMatchCard";
</style>
